import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'

import Loader from './shared/Loader'

import {Provider} from 'react-redux'
import store from './store'

import {usePromiseTracker} from "react-promise-tracker";
import {BrowserRouter} from "react-router-dom"


const rootElement = document.getElementById('root')

const LoadingIndicator = props => {
    const {promiseInProgress} = usePromiseTracker();
    return (
        promiseInProgress && <Loader></Loader>
    )
}

if (process.env.NODE_ENV !== "development") {
    //TODO: To hide console from production, uncomment the line below.
    // console.log = () => {
    // }
    // console.warn = () => {
    // }
    // console.error = () => {
    // }
}

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
        <LoadingIndicator></LoadingIndicator>
    </Provider>,
    rootElement
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

// store.subscribe(()=>{
//   console.log(store.getState(),"$$$$");
// })